module.exports = require('./assignIn');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/extend.js
// module id = 261
// module chunks = 0